export var InternalCompany;
(function (InternalCompany) {
    InternalCompany["Diqq"] = "Diqq";
    InternalCompany["Qompliance"] = "Qompliance";
    InternalCompany["Proteqt"] = "Proteqt";
    InternalCompany["DetaQ"] = "DetaQ";
    InternalCompany["Qlick"] = "Qlick";
    InternalCompany["Qgroup"] = "Qgroup";
    InternalCompany["Qbackoffice"] = "Qbackoffice";
})(InternalCompany || (InternalCompany = {}));
export const ClientContractStatusMap = new Map([
    [InternalCompany.Diqq, 'Diqq'],
    [InternalCompany.Qompliance, 'Qompliance'],
    [InternalCompany.Proteqt, 'Proteqt'],
    [InternalCompany.DetaQ, 'DetaQ'],
    [InternalCompany.Qlick, 'Qlick'],
    [InternalCompany.Qgroup, 'Qgroup'],
    [InternalCompany.Qbackoffice, 'Qbackoffice']
]);
InternalCompany;
export const InternalCompanyOptions = Object.values(InternalCompany).map((value) => ({
    label: ClientContractStatusMap.get(value) ?? value,
    value: value
}));
